import flatpickr from "flatpickr";
import { Polish } from "flatpickr/dist/l10n/pl.js";

import { setupCarousel } from "./carousel.js";

const showNewsForDate = date => {
  // const fDate = `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
  const fDate =
    ("0" + date.getDate()).slice(-2) +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    date.getFullYear();

  // build slider and show
  const container = $("#news-calendar-slider");
  // clear
  container.html("");
  container.html(
    '<div class="news-calendar-slider owl-carousel owl-theme"></div>'
  );

  const items = [];
  window.newsData
    .filter(item => item.date === fDate || item.date2 === fDate)
    .map(item => {
      items.push(item.html);
    });

  $(".news-calendar-slider").html(items.join(""));
  container.show();

  setupCarousel(".news-calendar-slider", { items: 1 });
};

// export const flatpickrE = flatpickr
export const setupCalendar = () => {
  // dodajmy jedną datę bo jak jest pusta tablica to włącza wszystkie
  let enabled = ["01-01-1989"];
  if (window.newsData) {
    enabled = enabled.concat(
      window.newsData.filter(item => item.date).map(item => item.date)
    );
    enabled = enabled.concat(
      window.newsData.filter(item => item.date2).map(item => item.date2)
    );
  }

  const container = $("#news-calendar");
  if (container.length > 0) {
    // pobierz newsy , pokaz kalendar
    flatpickr("#news-calendar-input", {
      dateFormat: "d-m-Y",
      inline: true,
      locale: Polish,
      onChange: function(e) {
        if (e[0]) {
          showNewsForDate(e[0]);
        }
      },
      enable: enabled
    });
  }
};
